import app from 'flarum/common/app';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';

export default class UpcomingEventsWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.events  = null;
    this.loading = true;
    this.loadEvents();
  }

  className() {
    return 'Kemze-UpcomingEventsWidget';
  }

  icon() {
    return 'fas fa-calendar-alt';
  }

  title() {
    return extractText(app.translator.trans('kemze-upcoming-events-widget.forum.widget.title'));
  }

  async loadEvents() {
    const now = new Date();
    const end = new Date();
    end.setMonth(end.getMonth() + 3);

    try {
      const response = await app.request({
        method: 'GET',
        url: `${app.forum.attribute('apiUrl')}/events`,
        params: {
          start: now.toISOString(),
          end:   end.toISOString(),
        },
      });

      const records = app.store.pushPayload(response);
      this.events = (Array.isArray(records) ? records : [records])
        .filter((e) => e.is_scheduled() && !e.is_deleted())
        .sort((a, b) => new Date(a.event_start()) - new Date(b.event_start()))
        .slice(0, 5);
    } catch {
      this.events = [];
    }

    this.loading = false;
    m.redraw();
  }

  formatCountdown(eventStart) {
    const now  = new Date();
    const start = new Date(eventStart);
    const diff  = start - now;

    if (diff <= 0) return app.translator.trans('kemze-upcoming-events-widget.forum.widget.happening_now');

    const days    = Math.floor(diff / 86400000);
    const hours   = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);

    if (days > 0)    return app.translator.trans('kemze-upcoming-events-widget.forum.widget.days',    { days });
    if (hours > 0)   return app.translator.trans('kemze-upcoming-events-widget.forum.widget.hours',   { hours });
    if (minutes > 0) return app.translator.trans('kemze-upcoming-events-widget.forum.widget.minutes', { minutes });

    return app.translator.trans('kemze-upcoming-events-widget.forum.widget.happening_now');
  }

  formatDate(date) {
    return new Date(date).toLocaleString(app.translator.getLocale(), {
      month:  'short',
      day:    'numeric',
      hour:   '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }

  content() {
    if (this.loading) {
      return <LoadingIndicator />;
    }

    if (!this.events || this.events.length === 0) {
      return (
        <div className="Kemze-UpcomingEventsWidget-empty">
          {app.translator.trans('kemze-upcoming-events-widget.forum.widget.empty')}
        </div>
      );
    }

    return (
      <ul className="Kemze-UpcomingEventsWidget-list">
        {this.events.map((event) => (
          <li key={event.id()} className="Kemze-UpcomingEventsWidget-item">
            <Link href={event.discussion_url()} className="Kemze-UpcomingEventsWidget-link">
              <span className="Kemze-UpcomingEventsWidget-title">
                {event.title()}
              </span>
              <span className="Kemze-UpcomingEventsWidget-meta">
                <span className="Kemze-UpcomingEventsWidget-date">
                  <i className="fas fa-clock" />
                  {' '}
                  {this.formatDate(event.event_start())}
                </span>
                <span className="Kemze-UpcomingEventsWidget-countdown">
                  {this.formatCountdown(event.event_start())}
                </span>
              </span>
              {event.location() && (
                <span className="Kemze-UpcomingEventsWidget-location">
                  <i className="fas fa-map-marker-alt" />
                  {' '}
                  {event.location()}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
